import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutEmployee } from "../service/EmployeeLoginService";


const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logoutEmployee(); 
    navigate("/admin/login"); 
  }, [navigate]);

  return null; 
};

export default Logout;
